(ns common.data-types
  #?(:cljs (:require
            [cljs.reader :as edn]))
  #?(:clj (:require
           [clojure.edn :as edn])))

(defn parse-edn-string
  [s]
  (if-not (string? s)
    s
    #?(:cljs (edn/read-string s)
       :clj (edn/read-string s))))


(defn field-span
  [data-type]
  (case data-type
    :data.type/text-multiline 4
    :data.type/ref-multi 2
    :data.type/keyword-multi 2
    1))
